import LinkedIn from './Linkedin.svg';
import GitHub from './Github.svg';
import ProfilePic from './ProfilePic.jpeg';

import Vestwoods from './Company_Logos/Vestwoods.jpeg';
import Tesla from './Company_Logos/Tesla.png';
import Foreseeson from './Company_Logos/Foreseeson.png';
import YiJiaHe from './Company_Logos/Yijiahe.jpeg';

import Thunderbots from './Projects_Logos/Thunderbots.png';
import FSAE from './Projects_Logos/FSAE.png';
import Capstone from './Projects_Logos/Capstone.png';
import Aerodesign from './Projects_Logos/Aerodesign.png';

import Humanoid from './Research_Logos/Humanoid.png';
import Foundation from './Research_Logos/Foundation.jpeg';
import LLM from './Research_Logos/LLM.png';
import Vision from './Research_Logos/Vision.png';

import AutoAStar from './Paper_Logos/AutoAStar.png';
import './App.css';

function App() {
  return (
    <div className="App-content-container">
      <title>Andy Zong 宗宁安</title>
      <div className="App-Title">
        <h1>Ning An (Andy) Zong</h1>
      </div>
      <hr size="1" width="100%" color="lightgray" />
      <br />
      <div className="App-Profile-Intro-Row">
        <img src={ProfilePic} className="App-ProfilePic" alt="ProfilePic"/>
        <div className="App-Intro-text">
          <p>
          I am a MSCS student at Georgia Tech specializing in Computational Perception and Robotics. My interests lie at the intersection of robot imitation learning, reinforcement learning, computer vision, and tweaking with robot hardware.
          Before getting into the computer science aspects of robotics I was a mechanical engineer with a BASc in Materials Engineering from the University of British Columbia. My most notable robotics project is a soccer-playing robot for the Robocup competition.
          <br /> <br /> You can reach me at: nzong8 at gatech dot edu
          </p>
          <a
            href="https://www.linkedin.com/in/ning-an-zong-320370177/"
            target="_blank"
            rel="noopener noreferrer"
          >
          <img src={LinkedIn} className="App-Socials" alt="LinkedIn"/>
          </a>
          <a
          href="https://github.com/andyzong16"
          target="_blank"
          rel="noopener noreferrer"
          >
          <img src={GitHub} className="App-Socials" alt="Github"/>
          </a>
        </div>
      </div>
      <h3><u>Papers, With More To Come!</u></h3>
      <div className="Publications">
        <div className="Paper">
          <img src={Humanoid} className="Paper-Thumbnail" alt="3D RFT"/>
          <div className="Paper-Content">
            <a
            href="https://norlab-ulaval.github.io/icra_workshop_field_robotics/"
            target="_blank"
            rel="noopener noreferrer"
            >
            <h4>Learning Humanoid Locomotion on Granular Terrain</h4>
            </a>
            <p>Junnosuke Kamohara, Feiyang Wu, <strong>Andy Ningan Zong</strong>, Chen-Yuan Li, Daniel I. Goldman, Yashwanth Nakka, Seth Hutchinson, Ye Zhao</p>
            <p>Accepted - IEEE Workshop at International Conference on Robotics and Automation 2026</p>
            <p>In Submission - Robotics and Automation Letters</p>
          </div>
        </div>
        <div className="Paper">
          <img src={AutoAStar} className="Paper-Thumbnail" alt="Auto A*"/>
          <div className="Paper-Content">
            <a
            href="https://drive.google.com/file/d/1_N23YK78q_r6A-yDpjMj09qLemPQk9eP/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            >
            <h4>Auto A*: An Improved Framework for Path Planning in Autonomous Systems</h4>
            </a>
            <p><strong>Andy Ningan Zong</strong>, Arshdeep Singh, Vijay Madisetti</p>
            <p>In Submission - IEEE International Conference on Robotics and Automation 2027</p>
          </div>
        </div>
      </div>
      <br />
      <h3><u>Research</u></h3>
      <div className="Research">
        <div className="Research-Projects">
          <img src={Humanoid} className="App-Thumbnail" alt="Humanoid Robot Physics Simulation"/>
          <h4>Georgia Tech LIDAR Lab - Advised By Prof. Ye Zhao</h4>
          <p>Building A 3D Soft Terrain Physics Simulation</p>
          <p>September 2025 - Present</p>
        </div>
        <div className="Research-Projects">
          <img src={Foundation} className="App-Thumbnail" alt="Robot Foundation Model" />
          <h4>Georgia Tech IVALAB - Advised By Prof. Patricio Vela</h4>
          <p>Controlling A Robot Arm Using A Vision-Language-Action (VLA)</p>
          <p>August 2025 - Present</p>
        </div>
        <div className="Research-Projects">
          <img src={LLM} className="App-Thumbnail" alt="LLM For Autonomous Systems Path Planning" />
          <h4>Georgia Tech LLM Applications Research - Advised By Prof. Vijay Madisetti</h4>
          <p>Using LLMs To Plan Paths For Autonomous Systems</p>
          <p>May 2025 - October 2025</p>
        </div>
        <div className="Research-Projects">
          <img src={Vision} className="App-Thumbnail" alt="Vision-Based Weld Inspection" />
          <h4>UBC Undergraduate Student Researcher</h4>
          <p>Tried To Inspect Weld Quality Using A High-Speed Camera</p>
          <p>October 2020 - March 2021</p>
        </div>
      </div>
      <br />
      <h3><u>Work Experience</u></h3>
      <div className="Work-Experience">
        <div className="Internship">
          <img src={Vestwoods} className="App-Logo-Thumbnail" alt="Vestwoods" />
          <h4>Vestwoods Technologies Inc</h4>
          <p>Electrical Test Engineering Intern</p>
          <p>November 2023 - January 2024</p>
        </div>
        <div className="Internship">
          <img src={Tesla} className="App-Logo-Thumbnail" alt="Tesla" />
          <h4>Tesla Inc</h4>
          <p>Cell Abuse Test Engineering Intern</p>
          <p>October 2021 - January 2022</p>
        </div>
        <div className="Internship">
          <img src={Foreseeson} className="App-Logo-Thumbnail" alt="Foreseeson" />
          <h4>Foreseeson Technology Inc</h4>
          <p>Mechanical Engineering Intern</p>
          <p>June 2020 - September 2020</p>
        </div>
        <div className="Internship">
          <img src={YiJiaHe} className="App-Logo-Thumbnail" alt="YiJiaHe" />
          <h4>YiJiaHe Technology Co., Ltd</h4>
          <p>Mechanical Design Engineering Intern</p>
          <p>May 2019 - August 2019</p>
        </div>
      </div>
      <br />
      <h3><u>Technical Projects</u></h3>
      <div className="Technical-Projects">
        <div className="Projects">
          <img src={Thunderbots} className="App-Thumbnail" alt="UBC Thunderbots"/>
          <h4>UBC Thunderbots</h4>
          <p>Experimented With A 3-Wheel Robot</p>
          <p>September 2020 - April 2023</p>
        </div>
        <div className="Projects">
          <img src={FSAE} className="App-Thumbnail" alt="UBC SAE Formula Electric" />
          <h4>UBC SAE Formula Electric</h4>
          <p>Built An Electric Race Car</p>
          <p>April 2021 - September 2022</p>
        </div>
        <div className="Projects">
          <img src={Capstone} className="App-Thumbnail" alt="UBC Materials Engineering Capstone Project" />
          <h4>UBC Materials Engineering</h4>
          <p>Cooked Heatshields In The Lab</p>
          <p>September 2022 - April 2023</p>
        </div>
        <div className="Projects">
          <img src={Aerodesign} className="App-Thumbnail" alt="UBC SAE AeroDesign" />
          <h4>UBC SAE AeroDesign</h4>
          <p>Designed A Glider</p>
          <p>September 2018 - April 2019</p>
        </div>
      </div>
      <br />
      <div className="Credits">
        <p>© Andy Zong 2025</p>
      </div>
    </div>
  );
}

export default App;
